import { IController } from 'angular';
import * as _ from 'lodash';

import { Cohort } from '../../../../../../../ng2/shared/constants/cohort.constant';
import { GraduationPlan as Plan } from '../../../../../../../ng2/shared/constants/graduation-plan.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class LocalAssignmentJuneCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  private activeStudentsByCohort;
  private filteredStudentsByGp;
  private superSeniorThreshold;
  public currentCohortFilter: string;
  public sort: string;
  public explainer: string;

  // studentIds: wizard-action-filter:
  public studentIdsWithCalcGpLocal: string[];
  public studentIdsWithCurrGpIncomplete: string[];
  public studentIdsWithCurrGpOther: string[];
  public studentIdsWithCurrGpLocal: string[];

  // _ids: to generate patches
  private _idsWithCalcLocal;

  // misc
  public filterOptions;
  public textOptions;
  public allEligibleStudentPatches;

  // disable btns after user action
  public actionTaken: boolean;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filterOptions = {
      columnKeys: ['gradPlan', 'plannedDiplomaType', 'plannedGraduationDate'],
      sort: [{ colId: 'countOfRegentsPassedAt65Of5', sort: 'desc' }],
    };

    this.superSeniorThreshold = _.find(Cohort, { studentYear: 4 }).value;
    this.currentCohortFilter = _.last(this.WizardUtils.getCurrentCohortFilter());
    this.explainer = this.WizardUtils.getGradPlanThresholdExplainer('Local', 'June');
    this.activeStudentsByCohort = this.WizardUtils.getFilteredFlattenedStudents({
      status: ['A', 'A-NDG'],
      cohort: [this.currentCohortFilter],
    });

    this.textOptions = { gradDate: `June ${this.currentCohortFilter}`, diplomaType: 'Local' };
    // bucketed students:
    this.filteredStudentsByGp = this.generateFilteredStudentIdBuckets();

    // studentIds[] : to generate filter for grid
    this.studentIdsWithCalcGpLocal = _.keys(this.filteredStudentsByGp.calculatedGpLocal);
    this.studentIdsWithCurrGpLocal = _.keys(this.filteredStudentsByGp.currentGpLocal);
    this.studentIdsWithCurrGpIncomplete = _.keys(this.filteredStudentsByGp.currentGpIncomplete);
    this.studentIdsWithCurrGpOther = _.keys(this.filteredStudentsByGp.currentGpOther);

    // student_ids[] : to patch students
    this._idsWithCalcLocal = _.values(this.filteredStudentsByGp.calculatedGpLocal);

    const diffs = _.difference(this._idsWithCalcLocal, _.values(this.filteredStudentsByGp.currentGpLocal));
    this.allEligibleStudentPatches = this.WizardUtils.getGradPlanningBulkPatch(
      diffs,
      this.textOptions.gradDate,
      'Local',
    );

    // user action: sets grad plans equal to the calc grad plan
    this.actionTaken = this.studentIdsWithCurrGpLocal.length === this.studentIdsWithCalcGpLocal.length;
  }

  private generateFilteredStudentIdBuckets(): object {
    const o = {
      calculatedGpLocal: {},
      currentGpIncomplete: {},
      currentGpLocal: {},
      currentGpOther: {},
    };
    // student is a modified student NOT IStudent
    _.each(this.activeStudentsByCohort, (student: any) => {
      const { studentId, calculatedGradPlan, gradPlan, cohort } = student;
      // only pass non-super-seniors thru filter
      if (Number(cohort) >= this.superSeniorThreshold) {
        if (calculatedGradPlan === Plan.LOCAL_4_YEAR_JUNE.humanName) {
          o.calculatedGpLocal[studentId] = student._id;
          const gradPlanIncomplete = gradPlan === Plan.PLAN_INCOMPLETE.humanName;
          const gradPlanInPast = gradPlan === Plan.PLAN_IN_PAST.humanName;
          if (gradPlanIncomplete || gradPlanInPast) return (o.currentGpIncomplete[studentId] = student._id);
          if (gradPlan === Plan.LOCAL_4_YEAR_JUNE.humanName) {
            return (o.currentGpLocal[studentId] = student._id);
          } else return (o.currentGpOther[studentId] = student._id);
        }
      }
    });
    return o;
  }
}
